<script setup lang="ts">
import { CheckCircleIcon, ExclamationCircleIcon, UserCircleIcon } from '@heroicons/vue/solid'
import { navigateToNextPageWithMissingFieldsForInvestmentPersonal } from '../../../utilities/account/useAccountNavigationPersonal'
import { usePersonalAccountDataState } from '../../../utilities/account/useAccountDataPersonal'
import { computed, defineProps, ref, watch } from 'vue'
import { i18n } from '../../../localization'
import Alert from '../../base/Alert.vue'
import { usePersonalAccountFormState } from '../../../utilities/account/useAccountFormPersonal'
import { getAccountLink } from '../../../utilities/useLinks'

const props = defineProps<{
    inline?: boolean
    descriptionText?: string
    onButtonClick?: () => void
}>()

const formStore = usePersonalAccountFormState()

async function onButtonClick() {
    if (props.onButtonClick) {
        await props.onButtonClick()
        return
    }

    if (window.location.href.includes(getAccountLink())) {
        formStore.missingDataProcessForVerificationActive = true
        await navigateToNextPageWithMissingFieldsForInvestmentPersonal()
    } else {
        window.location = getAccountLink() + '?action=missingDataProcessForVerification'
    }
}

const personalAccountDataStore = usePersonalAccountDataState()

const hasAllRequiredNaturalProfileAttributesForInvestment = ref(false)

watch(
    () => personalAccountDataStore.saving,
    () => {
        // @ts-ignore
        hasAllRequiredNaturalProfileAttributesForInvestment.value =
            personalAccountDataStore.hasAllRequiredNaturalProfileAttributesForInvestment
    }
)

const titleText = computed(() => {
    if (hasAllRequiredNaturalProfileAttributesForInvestment.value) {
        return i18n.global.t('verification.completed_data')
    } else {
        return i18n.global.t('verification.complete_data')
    }
})

const descriptionText = computed(() => {
    if (props.descriptionText) {
        return props.descriptionText
    }

    if (hasAllRequiredNaturalProfileAttributesForInvestment.value) {
        return i18n.global.t('verification.completed_data_description')
    } else {
        return i18n.global.t('verification.complete_data_description')
    }
})
</script>

<template>
    <Alert
        :inline="inline"
        :title-text="titleText"
        :description-text="descriptionText"
        :show-button="!hasAllRequiredNaturalProfileAttributesForInvestment"
        :button-text="i18n.global.t('verification.complete_data_action_button')"
        @click-button="onButtonClick">
        <template #icon>
            <UserCircleIcon class="h-12 w-12 text-gray-300"></UserCircleIcon>
            <ExclamationCircleIcon
                v-if="!hasAllRequiredNaturalProfileAttributesForInvestment"
                class="absolute bottom-0 right-[-5px] h-6 w-6 rounded-full bg-white text-red-400"></ExclamationCircleIcon>
            <CheckCircleIcon
                v-else
                class="absolute bottom-0 right-0 h-6 w-6 rounded-full bg-white text-green-500"></CheckCircleIcon>
        </template>
    </Alert>
</template>
